import Base64Util from '../../../utils/Base64Media';

export default {
    name: 'quote-image-message',
    props: ['message'],
    data() {
        return {
            isGif: false,
        };
    },
    computed: {
        base64() {
            const imageMsg = this.message.content.content;
            const content = imageMsg.content;
            return Base64Util.concat(content);
        },
    },
    methods: {
        showImage() {
            this.$emit('showImage');
        },
    },
    mounted() {
        const url = this.message.content.content.imageUri;
        const isGif = (/.*\.gif$/i).test(url);
        if (isGif) {
            this.isGif = true;
        }
    },
};
